import { Container, Row, Spinner } from "react-bootstrap";
import React from "react";

const SpinnerAnimation = ({ otherProps }) => (
    <div id={"spinner-container"}>
        <Spinner animation="border" {...otherProps} />
    </div>
);

const CustomSpinner = ({ row, container, ...otherProps }) => {
    if (row)
        return (
            <Row className="justify-content-center">
                <SpinnerAnimation {...otherProps} />
            </Row>
        );
    if (container)
        return (
            <Container className="d-flex flex-row justify-content-center align-items-center">
                <SpinnerAnimation {...otherProps} />
            </Container>
        );
    return <SpinnerAnimation {...otherProps} />;
};

export default CustomSpinner;
